import { useQuery } from '@tanstack/react-query';

import { getStoreData } from '../api/getStoreData';

export const useStoreDataQuery = () => {
  return useQuery({ queryKey: ['storeData'], queryFn: getStoreData });
};
